import { Component } from '@angular/core';

@Component({
  selector: 'app-credit-pruchase',
  templateUrl: './credit-pruchase.component.html',
  styleUrls: ['./credit-pruchase.component.css']
})
export class CreditPruchaseComponent {

}
